import styles from './About.module.scss'
import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger)

interface ExplanationList {
  src: string
  alt: string
  title: string
  text: string
}

const explanationLists: ExplanationList[] = [
  {
    src: '/images/LP/designsystem/about-icon.png',
    alt: 'デザイン原則',
    title: 'デザイン原則',
    text: 'プロダクトの核となる「らしさ」や「重要なことはなにか？」を定義・明文化したもの。',
  },
  {
    src: '/images/LP/designsystem/about-icon1.png',
    alt: 'デザインガイドライン',
    title: 'デザインガイドライン',
    text: 'デザインシステムのルールを記載したもの。レイアウトのルールや、コンポーネントの使用方法など。',
  },
  {
    src: '/images/LP/designsystem/about-icon2.png',
    alt: 'コンポーネントライブラリ',
    title: 'コンポーネントライブラリ',
    text: 'デザインパターンをコンポーネント化したFigmaのAssetsや、それと同期するReactライブラリなど。',
  },
  {
    src: '/images/LP/designsystem/about-icon3.png',
    alt: '各種リソース',
    title: '各種リソース',
    text: 'デザインシステムを運用していく上で必要なデザインファイルやドキュメントなど。',
  },
]

const About = () => {
  const slide = useRef<HTMLDivElement>()
  const section = useRef<HTMLElement>()
  useEffect(() => {
    gsap.to(slide.current, {
      width: 0,
      duration: 0.5,
      scrollTrigger: {
        trigger: section.current,
        start: 'top-=350 top+=200',
      },
    })
  }, [])

  const explanationList = explanationLists.map(({ src, alt, title, text }, index) => (
    <li key={index}>
      <img src={src} alt={alt} />
      <div>
        <p className={styles.title}>{title}</p>
        <p className={styles.text}>{text}</p>
      </div>
    </li>
  ))

  return (
    <section className={styles.about} ref={section}>
      <div className={styles.wrapper}>
        <div className={styles.ancker} id="about"></div>
        <div className={styles.intro}>
          <div className={styles.title}>
            <div className={styles.slider} ref={slide}></div>
            <span>About the design system</span>
            <h2>デザインシステムとは？</h2>
          </div>
          <div className={styles.description}>
            デザインシステムとは、デジタルプロダクトの一貫した体験をデザインするためのルールや、運用効率化などを目的としたパターンや実現のための一連のリソースなどを総合したものを指します。標準的な定義は難しいですが、大きくは組織におけるデザインのシステムを改善する取り組みといえます。基本的にはデザイン原則などのルールをまとめたガイドラインと、コンポーネントライブラリなどが含まれています。
          </div>
        </div>
        <div className={styles.explanation}>
          <h3>デザインシステムの構成要素</h3>
          <ul>{explanationList}</ul>
        </div>
      </div>
    </section>
  )
}

export default About
